import http from "@/plugins/axios_retail";

export default http.axiosInstance